// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiCookie from "lumi-rescript/lib/es6/src/LumiCookie.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Locale$LumiI18n from "./Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as JsCookieJs from "lumi-rescript/src/js-cookie.js";

function $$default(param) {
  
}

let SetLocale = LumiReact.Context.Make({
  $$default: $$default
});

let $$default$1 = ["ENG"];

let Locales = LumiReact.Context.Make({
  $$default: $$default$1
});

function Localization$CookieProvider(props) {
  let $$default = props.default;
  let match = React.useState(() => Stdlib_Option.getOr(Stdlib_Option.flatMap(JsCookieJs.get("language"), Locale$LumiI18n.fromString), $$default));
  let setLocale = match[1];
  let locale = match[0];
  React.useEffect(() => {
    LumiCookie.set("language", Locale$LumiI18n.toString(locale), 3650, undefined, undefined, undefined, "Strict", undefined);
  }, [locale]);
  return JsxRuntime.jsx(Locale$LumiI18n.Provider.make, {
    value: locale,
    children: JsxRuntime.jsx(SetLocale.Provider.make, {
      value: locale => setLocale(param => locale),
      children: JsxRuntime.jsx(Locales.Provider.make, {
        value: props.locales,
        children: props.children
      })
    })
  });
}

let CookieProvider = {
  make: Localization$CookieProvider
};

function Localization$FixedProvider(props) {
  let locale = props.locale;
  return JsxRuntime.jsx(Locale$LumiI18n.Provider.make, {
    value: locale,
    children: JsxRuntime.jsx(SetLocale.Provider.make, {
      value: param => {},
      children: JsxRuntime.jsx(Locales.Provider.make, {
        value: [locale],
        children: props.children
      })
    })
  });
}

let FixedProvider = {
  make: Localization$FixedProvider
};

export {
  SetLocale,
  Locales,
  CookieProvider,
  FixedProvider,
}
/* SetLocale Not a pure module */
